export const INPUT_CHIPS_ERRORS = {
  INPUT_VALUE_IN_LIST: 'inputChips.inputValueInList',
};
